import { translateErrorMessage } from './pocketbaseErrorMessage'

/**
 * URL эндпоинта POST-синхронизации CRM → employees (тот же origin, прокси Vite в dev).
 * Пусто — без HTTP-синхронизации, остаётся ручное совпадение employees в СУП.
 */
export function getCrmSyncPostPath(): string | null {
  const u = import.meta.env.VITE_CRM_SYNC_URL?.trim()
  if (!u) return null
  if (u.startsWith('http://') || u.startsWith('https://')) return u
  return u.startsWith('/') ? u : `/${u}`
}

export async function syncLocalEmployeeFromCrm(params: {
  email: string
  password: string
  crmToken: string
}): Promise<void> {
  const path = getCrmSyncPostPath()
  if (!path) return
  const res = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${params.crmToken}`,
    },
    body: JSON.stringify({ email: params.email.trim(), password: params.password }),
  })
  if (res.ok) return
  const text = await res.text()
  let msg = text
  try {
    const j = JSON.parse(text) as { message?: string }
    if (typeof j.message === 'string') msg = j.message
  } catch {
    /* plain text */
  }
  throw new Error(
    msg
      ? `${translateErrorMessage(msg)} (синхронизация CRM, код ${res.status})`
      : `Ошибка синхронизации с CRM (код ${res.status})`,
  )
}
